export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preconnect","href":"https://cdncf.econnect.eu","crossorigin":""},{"rel":"dns-prefetch","href":"https://cdncf.econnect.eu"},{"rel":"preload","href":"https://cdncf.econnect.eu/fonts/0.2.0-rc-20260914115326/fonts/allroundgothic-demi.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"https://cdncf.econnect.eu/fonts/0.2.0-rc-20260914115326/fonts/allroundgothic-medium.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preconnect","href":"https://cdn.econnect.eu","crossorigin":""},{"rel":"dns-prefetch","href":"https://cdn.econnect.eu"},{"rel":"preconnect","href":"https://images.econnect.eu"},{"rel":"dns-prefetch","href":"https://images.econnect.eu"},{"rel":"dns-prefetch","href":"https://support.econnect.eu"}],"style":[{"innerHTML":"html{background-color:oklch(98.39% 0.0025 228.78)}html.dark{background-color:oklch(16.34% 0.0279 273.08)}.container{width:100%;margin-inline:auto;padding-inline:1rem}@media(min-width:1556px){.container{max-width:1556px}}@media(min-width:1832px){.container{max-width:1832px}}","tagPosition":"head"}],"script":[{"innerHTML":"try{var s=localStorage.getItem('econnect-appearance')||localStorage.getItem('vueuse-color-scheme');if(s==='dark'||(s!=='light'&&matchMedia('(prefers-color-scheme:dark)').matches))document.documentElement.classList.add('dark')}catch(e){}","tagPosition":"head"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false